import { ArchiveAlertOutlineIcon } from './ArchiveAlertOutlineIcon';

/**
 * author: Austin Andrews
 * id 1D17B03B-9147-4067-8F5E-88773D68289E
 * name archive-alert-outline
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const BoxAlertOutlineIcon = ArchiveAlertOutlineIcon;
export default BoxAlertOutlineIcon